var map = {
	"./404.svg": 2061,
	"./501.svg": 4186,
	"./add-document-by-code.svg": 3814,
	"./add-document.svg": 9273,
	"./alert-error.svg": 2749,
	"./alert-success.svg": 9215,
	"./back-blue.svg": 5304,
	"./back-right-white.svg": 7495,
	"./back-white.svg": 7386,
	"./clip-hover.svg": 49,
	"./clip.svg": 9452,
	"./clock-icon.svg": 459,
	"./close-hover.svg": 8154,
	"./close.svg": 5491,
	"./document-checked.svg": 5421,
	"./document-error.svg": 2629,
	"./document-meta.svg": 9913,
	"./document-uploading-animate.svg": 7436,
	"./document-warning.svg": 2426,
	"./eye-hover.svg": 9522,
	"./eye.svg": 3179,
	"./next.svg": 7179,
	"./not-available.svg": 9959,
	"./ocr.svg": 5834,
	"./panel-document-info-grey.svg": 2869,
	"./play.svg": 5019,
	"./question-hover.svg": 8859,
	"./question.svg": 6784,
	"./report-verify-hover.svg": 6288,
	"./report-verify.svg": 760,
	"./teacher-img.svg": 1574,
	"./tree-down.svg": 9612,
	"./tree-right.svg": 6948,
	"./user.svg": 5726,
	"./webinars-hover.svg": 1336,
	"./webinars.svg": 7277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4953;